const exportFile = async ({ url, document, filename, notif, type }) => {
    const fetchUrl = await fetch(url);
    const blob = await fetchUrl.blob();

    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.setAttribute('target', '_blank');
    a.download = `${filename}.${type}`;

    // Adds support for firefox
    document.body.appendChild(a);

    a.click();
    a.remove();

    if (notif) notif();
};

export default exportFile;
